import { render, staticRenderFns } from "./PersonalWallpaperItem.vue?vue&type=template&id=173fcd3f&scoped=true&"
import script from "./PersonalWallpaperItem.vue?vue&type=script&lang=js&"
export * from "./PersonalWallpaperItem.vue?vue&type=script&lang=js&"
import style0 from "./PersonalWallpaperItem.vue?vue&type=style&index=0&id=173fcd3f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173fcd3f",
  null
  
)

export default component.exports